"use client"

import dynamic from "next/dynamic"
import { useRouter } from "next/navigation"
import { useCallback } from "react"

const VideoPlayer = dynamic(() => import("@/components/shows/videoPlayer"), {
   ssr: false,
   loading: () => (
      <div
         className="flex w-full items-center justify-center rounded-xl bg-gray-900"
         style={{ aspectRatio: "16/9", minHeight: "300px" }}
      >
         <div className="animate-pulse">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/20">
               <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
               </svg>
            </div>
         </div>
      </div>
   ),
})

interface Props {
   url: string
   nextVideoHref?: string | null
   title?: string
}

export default function ClientVideoPlayer({ url, nextVideoHref, title }: Props) {
   const router = useRouter()

   const handleEnded = useCallback(() => {
      if (!nextVideoHref) return
      router.push(nextVideoHref)
   }, [nextVideoHref, router])

   return <VideoPlayer url={url} onEnded={handleEnded} title={title} />
}
